<template>
  <div class="input-group">
    <span class="input-group-btn">
        <button :class="buttonCssComputed"
                type="button"
                v-on:click="buttonRemove"
                :disabled="this.localQuantity <= min"
                :aria-label="this.localQuantity <= min ? 'Minimum quantity reached' : 'Remove product'"
        >
            <slot name="minus">
              <em class="ti-minus"></em>
              <span class="no-vis">Remove product</span>
            </slot>
        </button>
    </span>
    <input type="text"
           class="form-control text-center"
           aria-label="Products No"
           v-model.number="localQuantity"
           v-on:change="checkQuantity">
    <span class="input-group-btn">
      <button :class="buttonCssComputed"
              type="button"
              v-on:click="buttonAdd"
              :disabled="this.localQuantity >= max"
              :aria-label="this.localQuantity >= max ? 'Maximum quantity reached' : 'Add product'"
      >
          <slot name="plus">
            <em class="ti-plus"></em>
            <span class="no-vis">Add product</span>
          </slot>
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AdvInputSpinner',
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number
    },
    buttonCss: {
      type: String
    },
    quantity: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      version: '0.0.3',
      localQuantity: this.quantity
    }
  },
  watch: {
    quantity (val) {
      this.localQuantity = val
    }
  },
  computed: {
    buttonCssComputed () {
      return this.buttonCss || 'btn btn-default btn-number'
    }
  },
  methods: {
    checkQuantity () {
      if (this.localQuantity < this.min) {
        this.localQuantity = this.min
      }

      if (this.localQuantity > this.max) {
        this.localQuantity = this.max
      }

      this.emitQuantity()
    },
    buttonRemove () {
      this.localQuantity -= 1
      this.checkQuantity()
    },
    buttonAdd () {
      this.localQuantity += 1
      this.checkQuantity()
    },
    emitQuantity () {
      this.$emit('quantity-changed', this.localQuantity)
    }
  }
}
</script>
